import { render, staticRenderFns } from "./PromotionView.vue?vue&type=template&id=5f66ba12&scoped=true"
import script from "./PromotionView.vue?vue&type=script&lang=js"
export * from "./PromotionView.vue?vue&type=script&lang=js"
import style0 from "./PromotionView.vue?vue&type=style&index=0&id=5f66ba12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f66ba12",
  null
  
)

export default component.exports